export default "__VITE_ASSET__5551034e__"